export default function SwiggyBanner(){
    return(
        <div className="mb-10" >
            <img src="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/seo/App_download_banner.png" />
        </div>
    )
}